import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import UserPanel from './components/UserPanel';
import ContactsKiosk from './components/ContactsKiosk';
import AdminApp from './components/admin/AdminApp';
import ActivateDevicePage from './components/ActivateDevicePage';
import { LanguageProvider } from './i18n/LanguageContext';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <LanguageProvider>
              <UserPanel />
            </LanguageProvider>
          }
        />
        <Route
          path="/contatti"
          element={
            <LanguageProvider>
              <ContactsKiosk />
            </LanguageProvider>
          }
        />
        <Route path="/attiva" element={<ActivateDevicePage />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}
